import MenuAnnounce from "../../component/menu.announce.tsx";
import {useEffect, useState} from "react";
import {Api} from "../../../modules/api.ts";
import type {DaoApiAnnounce} from "../../../daos/dao-api-announce.ts";
import {onair} from "../../../modules/config.ts";
import type {DaoMedia} from "../../../daos/dao-media.ts";
import _ from "lodash";
import {Announce} from "../../component/announce.tsx";
import type {DaoCategory} from "../../../daos/dao-category.ts";
import {Utils} from "../../../modules/utils.ts";


function PageAnnounce() {
  const [menu, setMenu] = useState<DaoCategory>();
  const [apiDatas, setApiDatas] = useState<DaoApiAnnounce>();
  const [announces, setAnnounces] = useState<DaoMedia[]>([]);

  useEffect(() => {
    (async () => {
      const rs = await Api.announces();
      const daoApiAnnounce = rs.data as DaoApiAnnounce;
      daoApiAnnounce.medias.SCHEDULE = onair.getAdvertises() as DaoMedia[];
      setApiDatas(daoApiAnnounce);
    })();
  }, []);

  useEffect(() => {
    if(!_.isEmpty(menu)) {
      switch (menu?.no) {
        case 'celebrate':
          setAnnounces(apiDatas?.medias?.CELEBRATE ?? []);
          break;
        case 'common':
          setAnnounces(apiDatas?.medias?.COMMON ?? []);
          break;
        case 'schedule':
        default:
          setAnnounces(apiDatas?.medias?.SCHEDULE ?? []);
          break;
      }
    }
  }, [menu, apiDatas?.medias]);

  function announceChangeHandler(menu: DaoCategory) {
    setAnnounces([]);
    setMenu(menu);
  }

  function listenHandler(announce: DaoMedia) {
    if(announce) {
      const start_ms = onair.millisecond + 1000;
      const duration: number = announce.duration + 1;
      onair.setSchedule(
        onair.getPriority(announce.type),
        [
          Object.assign({...announce}, {
            duration,
            start_base: Utils.toDateString(Utils.now(start_ms)),
            start: Utils.toDateString(Utils.now(start_ms)),
            end: Utils.toDateString(Utils.now(start_ms + (duration * 1000)))
          })
        ]
      );
    }
  }

  return (
    <main>
      <section className="contents">
        <MenuAnnounce callback={announceChangeHandler} />

        <div className="announce-list">
          <div className="scroll-gradient-top"></div>
          <div className="scroll-gradient-bottom"></div>
          <div className="announce-list-inner">
            {
              announces.length < 1 ?

                <article className="channel-item">
                  {menu?.name ?? '일반'}에 등록된 안내방송이 없습니다.
                </article> :

                announces.map((announce: DaoMedia, idx: number) => (
                  <Announce key={idx} announce={announce} listenCallback={listenHandler} />
                ))
            }
          </div>
        </div>
      </section>
    </main>
  )
}

export default PageAnnounce;